import flow from 'lodash/flow';
import connectAsync from '../../utils/connectAsync';
import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import withLotameTargeting from '../../decorators/ads/withLotameTargeting';

import { createVanityProfileContext } from '../../routes/utils/getProfileContext';
import fetchTopic from '../../utils/connectors/fetchTopic';
import fetchProfile from '../../utils/connectors/fetchProfile';
import fetchAudioClip from '../../utils/connectors/fetchAudioClip';
import ProfileLoader from './ProfileLoader';

export default flow(
  withAdScreenRequest(() => 'profile'),
  withLotameTargeting,
  connectAsync([
    fetchProfile(createVanityProfileContext),
    fetchTopic(createVanityProfileContext),
    fetchAudioClip(createVanityProfileContext),
  ]),
)(ProfileLoader);
